import React from "react";
import { Link } from "react-router-dom";
import { onscroll, scrollTo, select } from "../../shared/utils";
import ReactGA from "react-ga";

class Header extends React.Component {

    componentDidMount() {
        this.handleHeaderScroll();
        this.handleNavbar();
    }

    handleHeaderScroll() {
        let selectHeader = select("#header");
        if (selectHeader) {
            const headerScrolled = () => {
                if (window.scrollY > 100) {
                    selectHeader.classList.add("header-scrolled");
                } else {
                    selectHeader.classList.remove("header-scrolled");
                }
            };
            window.addEventListener("load", headerScrolled);
            onscroll(document, headerScrolled);
        }
    }

    handleNavbar() {
        let navbarLinks = select("#navbar .scrollto", true);
        const navbarLinksActive = () => {
            let position = window.scrollY + 200;
            navbarLinks.forEach((navbarLink) => {
                if (!navbarLink.hash) return;
                let section = select(navbarLink.hash);
                if (!section) return;
                if (
                    position >= section.offsetTop &&
                    position <= section.offsetTop + section.offsetHeight
                ) {
                    navbarLink.classList.add("active");
                } else {
                    navbarLink.classList.remove("active");
                }
            });
        };
        window.addEventListener("load", navbarLinksActive);
        onscroll(document, navbarLinksActive);
    }

    handleToggleClick(event) {
        const el = event.target;
        select("#navbar").classList.toggle("navbar-mobile");
        el.classList.toggle("bx-menu");
        el.classList.toggle("bx-x");
    }

    handleLinkClick(event) {
        if (select(event.target.hash)) {
            event.preventDefault();

            let navbar = select("#navbar");
            if (navbar.classList.contains("navbar-mobile")) {
                navbar.classList.remove("navbar-mobile");
                let navbarToggle = select(".mobile-nav-toggle");
                navbarToggle.classList.toggle("bx-menu");
                navbarToggle.classList.toggle("bx-x");
            }
            ReactGA.event({ category: 'Home Page', event: 'page-click', label: event.target.hash });
            ReactGA.send({ hitType: "pageview", page: window.location.href });
            scrollTo(event.target.hash);
        }
    }

    render() {
        return (
            <header id="header" className="fixed-top  header-transparent " >
                <div className="container d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <h1>
                            <Link to="/">ExpenseGenie</Link>
                        </h1>
                    </div>

                    <nav id="navbar" className="navbar">
                        <ul>
                            <li>
                                <Link className="nav-link scrollto active" to="/#hero" onClick={(e) => this.handleLinkClick(e)}>Home</Link>
                            </li>
                            <li>
                                <Link className="nav-link scrollto" to="/#features" onClick={(e) => this.handleLinkClick(e)}>App Features</Link>
                            </li>
                            <li>
                                <Link className="nav-link scrollto" to="/#gallery" onClick={(e) => this.handleLinkClick(e)}>Gallery</Link>
                            </li>
                            {/* <li>
                                <Link className="nav-link scrollto" to="/#pricing" onClick={(e) => this.handleLinkClick(e)}>Pricing</Link>
                            </li> */}
                            <li>
                                <Link className="nav-link scrollto" to="/#faq" onClick={(e) => this.handleLinkClick(e)}>F.A.Q</Link>
                            </li>

                            <li>
                                <Link className="nav-link scrollto" to="/#contact" onClick={(e) => this.handleLinkClick(e)}>Contact</Link>
                            </li>
                            {/* <li>
                                <Link
                                    className="getstarted scrollto"
                                    to="/#features"
                                >
                                    Get Started
                                </Link>
                            </li> */}
                        </ul>
                        <i className="bx bx-menu mobile-nav-toggle" onClick={(e) => this.handleToggleClick(e)}></i>
                    </nav>
                </div>
            </header>
        );
    }
};

export default Header;
